import * as AC from '../actions/actionTypes';
import {updateObject} from '../utils/utilities';

const initialState = {
  user: null,
  authError: '',
  authLoading: false,
  sentResetPasswordEmail: false,
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case AC.LOGIN_REQUEST:
    case AC.GET_MY_PROFILE_REQUEST:
    case AC.FORGOT_PASSWORD_REQUEST:
    case AC.EDIT_PROFILE_REQUEST:
      return updateObject(state, {authLoading: true});
    case AC.LOGIN_SUCCEED:
    case AC.GET_MY_PROFILE_SUCCEED:
      return updateObject(state, {user: action.payload, authLoading: false});
    case AC.FORGOT_PASSWORD_SUCCEED:
      return updateObject(state, {
        sentResetPasswordEmail: true,
        authLoading: false,
        authError: '',
      });
    case AC.LOGIN_FAILED:
    case AC.GET_MY_PROFILE_FAILED:
    case AC.FORGOT_PASSWORD_FAILED:
    case AC.EDIT_PROFILE_FAILED:
      return updateObject(state, {
        authError: action.payload,
        authLoading: false,
      });
    case AC.REMOVE_AUTH_ERROR:
      return updateObject(state, {authError: ''});
    case AC.LOG_OUT:
      return updateObject(state, {user: null, authError: ''});
    case AC.SET_EMAIL_SENT_TO_FALSE:
      return updateObject(state, {sentResetPasswordEmail: false});
    default:
      return state;
  }
};

export default userReducer;
